import { render, staticRenderFns } from "./game-footer.vue?vue&type=template&id=6a8bcf56"
import script from "./game-footer.vue?vue&type=script&lang=js"
export * from "./game-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports